export class DatabaseUserGroupAttribute {
    id: number = 0;
    key: string = "";
    value: string = "";
}
